import React from 'react';

import classes from './TrustStats.module.scss';

// The teal stats band first built for the home page hero. Content comes from the
// caller so pages can show a different set of stats.
const TrustStats = ({ items = [], columnClassName = 'col-12 col-md-3' }) => {
    return (
        <div className={classes['stats-section']}>
            <div className='container'>
                <div className='row'>
                    {items.map((item) => (
                        <div key={item.title} className={`${columnClassName} justify-content-center d-flex`}>
                            <div className={classes['stat-item']}>
                                <div className={classes['icon-wrapper']}>
                                    {item.icon}
                                </div>
                                <p>{item.label}</p>
                                <h4>{item.title}</h4>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TrustStats;
